import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, withCtx as _withCtx } from "vue"

import {
    PickAndPackHomeDeliveryCheckOutDeliveryOption,
} from '@/b2c/shared/api/server-apis';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import CheckoutRadioButton from '@/shared/checkout/ui/CheckoutRadioButton.vue';
import CheckoutPickAndPackHomeDeliveryInfo from '@/b2c/checkout/ui/deliverables/pick-and-pack/CheckoutPickAndPackHomeDeliveryInfo.vue';
import { useField } from 'vee-validate';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPickAndPackHomeDeliveryOption',
  props: {
    deliveryOption: null,
    deliverableId: null
  },
  setup(__props: any) {



const labels = useBlockLabels();

const { value } = useField('pickAndPack');


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CheckoutRadioButton, {
    modelValue: _unref(value),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
    value: __props.deliveryOption.deliveryType,
    label: _unref(labels).pickAndPackHomeDeliveryTitle + ' - ' + __props.deliveryOption.price.amount,
    "is-selected": __props.deliveryOption.isSelected,
    name: "pickAndPack"
  }, {
    default: _withCtx(() => [
      (_unref(value) === __props.deliveryOption.deliveryType)
        ? (_openBlock(), _createBlock(CheckoutPickAndPackHomeDeliveryInfo, {
            key: 0,
            class: "mt-x3",
            "deliverable-id": __props.deliverableId,
            "delivery-option": __props.deliveryOption
          }, null, 8, ["deliverable-id", "delivery-option"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "value", "label", "is-selected"]))
}
}

})